export const deviceCode =  [
    {
      name: "门禁设备",
      value: 'ASI',
    },
    {
      name: "数据传输单元DTU",
      value: 'DTU',
    }
  ]

  export const openDoorType =  [
    {
      name: "人脸识别",
      value: 'Face',
    },
    {
      name: "远程开门",
      value: 'Remote',
    },
    
  ]


  export const activeStatusType =  [
    {
      name: "在线",
      value: 1,
    },
    {
      name: "离线",
      value: 0,
    },
    
  ]


  export const protocolType =  [
    {
      name: "MQTT",
      value: 'MQTT',
    },
    {
      name: "TCP",
      value: 'TCP',
    },
    {
      name: "Modbus TCP",
      value: 'MBTCP',
    },
    {
      name: "Modbus RTU",
      value: 'MBRTU',
    },
    
  ]


  export const dataType =  [
    {
      value: "boolean",
      name: '布尔类型',
    },
    {
      value: "int16",
      name: '16位整数',
    },
    {
      value: "int32",
      name: '32位整数',
    },
    {
      value: "float32",
      name: '浮点型',
    },{
      value: "uint16",
      name: '16位无符号数',
    },
    
  ]


  export const functionCodeType =  [
    {
      name: "01 读写线圈",
      value: 1,
    },
    {
      name: "02 读写离散输入",
      value: 2,
    },
    {
      name: "03 读写保持寄存器",
      value: 3,
    },
    {
      name: "04 读写输入寄存器",
      value: 4,
    }
    
  ]


  /**
   * 字节序
   */
  export const byteOrderType =  [
    {
      name: "ABCD-大端形式",
      value: 'abcd',
    },
    {
      name: "BADC-大端单字节反转",
      value: 'badc',
    },
    {
      name: "DCBA-小端形式",
      value: 'dcba',
    },
    {
      name: "CDAB-小端单字节反转",
      value: 'cdab',
    },
    
  ]


